var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmailSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9924 6.99707L13.0048 12.7219C12.6998 12.899 12.3534 12.9923 12.0007 12.9923C11.648 12.9923 11.3016 12.899 10.9966 12.7219L2 6.99707",
    stroke: "#171C60",
    strokeWidth: 1.99924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9932 3.99805H3.99924C2.89509 3.99805 2 4.89314 2 5.99729V17.9927C2 19.0969 2.89509 19.992 3.99924 19.992H19.9932C21.0973 19.992 21.9924 19.0969 21.9924 17.9927V5.99729C21.9924 4.89314 21.0973 3.99805 19.9932 3.99805Z",
    stroke: "#171C60",
    strokeWidth: 1.99924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailSmall);
export default __webpack_public_path__ + "static/media/icon_email_small.89862f6fb3079d2653b8e1c4689cee35.svg";
export { ForwardRef as ReactComponent };